import React, { useRef, useState } from "react";
import "./Mid-Section-Pc.scss";
import { useSelector } from "react-redux";

//components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";

//icons
import { IoIosArrowRoundDown } from "react-icons/io";
import { FaHome, FaSpinner, FaTrash, FaClock } from "react-icons/fa";
import { MdWaterDrop } from "react-icons/md";
import { LiaFileInvoiceSolid } from "react-icons/lia";
// removed unused icon imports (we now use avatars for transactions)
import { IoIosArrowForward } from "react-icons/io";
import { MyCalendar } from "./ReactCalender";
import IncomeDetailsPage from "./IncomeDetailsPage";

export default function MidSectionReportsPc() {
  const currentYear = new Date().getFullYear();
  const timePeriodChoices = ["Last 6 months", "Last 1 year", "Last 2 years"];
  const incomeDetailMonthChoices = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const incomeDetailYearChoices = Array.from({ length: 4 }, (_, index) =>
    String(currentYear - index),
  );
  const [selectedTimePeriod, setSelectedTimePeriod] = useState(
    timePeriodChoices[0],
  );
  const [selectedIncomeCard, setSelectedIncomeCard] = useState(null);
  const [incomeDetailMonth, setIncomeDetailMonth] = useState(
    incomeDetailMonthChoices[new Date().getMonth()],
  );
  const [incomeDetailYear, setIncomeDetailYear] = useState(
    incomeDetailYearChoices[0],
  );
  const [selectedIncomeApartment, setSelectedIncomeApartment] =
    useState("All apartments");
  const [showAllTransactions, setShowAllTransactions] = useState(false);
  const visitChartRef = useRef(null);
  const [hoveredVisitPoint, setHoveredVisitPoint] = useState(null);

  const properties = useSelector((state) => state.landlordslice?.properties);
  const [selectedPropertyId, setSelectedPropertyId] = useState("");
  const propertyChoices = Array.isArray(properties)
    ? properties.map((p) => p.property_name || p.name)
    : [];
  const selectedProperty = Array.isArray(properties)
    ? properties.find((p) => (p.property_name || p.name) === selectedPropertyId)
    : null;
  const propertyId = selectedProperty?.property_id || selectedProperty?._id || null;

  const handleExportRange = () => {
    if (!propertyId) {
      alert("No property selected/found. Please ensure you have properties.");
      return;
    }

    // Convert time period to a date range ending today
    const endDate = new Date();
    let startDate = new Date();

    if (selectedTimePeriod === "Last 6 months") {
      startDate.setMonth(endDate.getMonth() - 6);
    } else if (selectedTimePeriod === "Last 1 year") {
      startDate.setFullYear(endDate.getFullYear() - 1);
    } else if (selectedTimePeriod === "Last 2 years") {
      startDate.setFullYear(endDate.getFullYear() - 2);
    }

    const startMonth = startDate.getMonth() + 1;
    const startYear = startDate.getFullYear();
    const endMonth = endDate.getMonth() + 1;
    const endYear = endDate.getFullYear();

    try {
      const baseUrl = process.env.REACT_APP_ENDPOINT;
      const url = `${baseUrl}/reports/export/range?propertyId=${propertyId}&startMonth=${startMonth}&startYear=${startYear}&endMonth=${endMonth}&endYear=${endYear}`;
      window.open(url, '_blank');
    } catch (error) {
      console.error("Export error", error);
      alert("Error exporting report");
    }
  };

  const dayTransactions = [
    {
      firstName: "John K",
      apartment: "Sunrise 2B",
      amount: 5000,
      profileUrl: null,
      initials: "JK",
      avatarClass: "tile-blue",
    },
    {
      firstName: "Aisha",
      apartment: "Block C - 12",
      amount: 3200,
      profileUrl: null,
      initials: "A",
      avatarClass: "tile-orange",
    },
    {
      firstName: "Michael",
      apartment: "Oakview 4A",
      amount: 2800,
      profileUrl: null,
      initials: "M",
      avatarClass: "tile-blue",
    },
    {
      firstName: "Sam",
      apartment: "Maple 1C",
      amount: 4100,
      profileUrl: null,
      initials: "S",
      avatarClass: "tile-orange",
    },
  ];

  // report cards now represent income items with numeric amounts (in KSH)
  const reportCards = [
    {
      title: "Rent Collected",
      amount: 20000,
      icon: <FaHome className="report-icon" />,
      iconClass: "brand-4",
    },
    {
      title: "Garbage Paid",
      amount: 3000,
      icon: <FaTrash className="report-icon" />,
      iconClass: "brand-2",
    },
    {
      title: "Water Paid",
      amount: 1500,
      icon: <MdWaterDrop className="report-icon" />,
      iconClass: "brand-3",
    },
    {
      title: "Arrears Paid",
      amount: 4500,
      icon: <FaClock className="report-icon" />,
      iconClass: "brand-1",
    },
    {
      title: "Deposit Paid",
      amount: 2200,
      icon: <LiaFileInvoiceSolid className="report-icon" />,
      iconClass: "brand-2",
    },
    {
      title: "Other Income",
      amount: 800,
      icon: <FaSpinner className="report-icon" />,
      iconClass: "brand-4",
    },
  ];

  const visitChartData = [
    { month: "Jan", value: 4.5, amount: 4500, transactions: 9 },
    { month: "Feb", value: 5.8, amount: 5800, transactions: 12 },
    { month: "Mar", value: 2.2, amount: 2200, transactions: 5 },
    { month: "Apr", value: 6.1, amount: 6100, transactions: 13 },
    { month: "May", value: 3.3, amount: 3300, transactions: 7 },
    {
      month: "Jun",
      value: 8.2,
      amount: 8200,
      transactions: 17,
      highlighted: true,
    },
    { month: "Jul", value: 2.0, amount: 2000, transactions: 4 },
    { month: "Aug", value: 4.7, amount: 4700, transactions: 10 },
    { month: "Sep", value: 2.8, amount: 2800, transactions: 6 },
    { month: "Oct", value: 5.5, amount: 5500, transactions: 11 },
    { month: "Nov", value: 4.1, amount: 4100, transactions: 8 },
    { month: "Dec", value: 6.0, amount: 6000, transactions: 14 },
  ];

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const currentMonthShort = monthNames[new Date().getMonth()];
  const currentMonthInData = visitChartData.some(
    (d) => d.month === currentMonthShort,
  );

  // compute max amount and Y-axis ticks (show amounts instead of abstract values)
  const maxAmount = Math.max(...visitChartData.map((d) => d.amount || 0));
  const yTickCount = 5; // number of segments (will produce yTickCount+1 ticks including 0)
  const yTicks = Array.from({ length: yTickCount + 1 }, (_, i) =>
    Math.round((maxAmount * (yTickCount - i)) / yTickCount),
  );

  const formatAmount = (value) =>
    Number(value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

  // short format for axis ticks: 2.6k, 1.2m, etc.
  const formatShortAmount = (value) => {
    const num = Number(value || 0);
    const abs = Math.abs(num);
    if (abs >= 1000000) {
      return `${Number((num / 1000000).toFixed(1)).toString()}m`;
    }
    if (abs >= 1000) {
      return `${Number((num / 1000).toFixed(1)).toString()}k`;
    }
    return formatAmount(num);
  };

  if (selectedIncomeCard) {
    return (
      <div className="mid-section-Reports-pc income-detail-mode">
        <IncomeDetailsPage
          selectedIncomeCard={selectedIncomeCard}
          incomeDetailMonth={incomeDetailMonth}
          setIncomeDetailMonth={setIncomeDetailMonth}
          incomeDetailYear={incomeDetailYear}
          setIncomeDetailYear={setIncomeDetailYear}
          incomeDetailYearChoices={incomeDetailYearChoices}
          selectedIncomeApartment={selectedIncomeApartment}
          setSelectedIncomeApartment={setSelectedIncomeApartment}
          properties={properties}
        />
      </div>
    );
  }

  const handleVisitHover = (event, item) => {
    if (!visitChartRef.current) return;

    const containerRect = visitChartRef.current.getBoundingClientRect();
    const barRect = event.currentTarget.getBoundingClientRect();
    const estimatedTooltipWidth = 220;
    const rightGap = 10;

    // Position tooltip to the right edge of the bar and allow overflow
    const rawLeft = barRect.right - containerRect.left + rightGap;
    const tooltipLeft = rawLeft; // intentionally do not clamp to container width
    const tooltipTop = Math.max(8, barRect.top - containerRect.top - 2);

    setHoveredVisitPoint({
      ...item,
      left: tooltipLeft,
      top: tooltipTop,
      color: item.highlighted ? "#192A3A" : "#B39359",
    });
  };

  return (
    <div>
      <div className="mid-section-Reports-pc">
        <div className="left-side">
          <div className="top-section-reports">
            <div className="introduction">
              <div className="title">
                Property Reports
                <div className="description">
                  Here are the reports for your properties
                </div>
              </div>
            </div>
            <div className="filters">
              <div className="time-container">
                <DropdownSelect
                  choices={propertyChoices}
                  defaultChoice={selectedPropertyId || "Select Property"}
                  onSelect={setSelectedPropertyId}
                  borderRadius={"25px"}
                  showIcon={true}
                  padding={"5px 7px"}
                  backgroundColor={"#ffffff"}
                />
              </div>
              <div className="time-container">
                <DropdownSelect
                  choices={timePeriodChoices}
                  defaultChoice={selectedTimePeriod}
                  onSelect={setSelectedTimePeriod}
                  borderRadius={"25px"}
                  showIcon={true}
                  padding={"5px 7px"}
                  backgroundColor={"#ffffff"}
                />
              </div>
              <div className="export-button" onClick={handleExportRange} style={{ cursor: "pointer" }}>
                <IoIosArrowRoundDown className="icon" />
                <div>Export</div>
              </div>
            </div>
          </div>

          <div className="report-card-section">
            {(() => {
              const totalAmount = reportCards.reduce(
                (s, c) => s + (c.amount || 0),
                0,
              );
              const fmt = new Intl.NumberFormat();

              return reportCards.map((card) => {
                const amount = card.amount || 0;
                const percentCollected =
                  totalAmount > 0
                    ? Math.round((amount / totalAmount) * 1000) / 10
                    : 0; // one decimal
                const percentBalance =
                  Math.round((100 - percentCollected) * 10) / 10;

                return (
                  <button
                    type="button"
                    className="report-card"
                    key={card.title}
                    onClick={() => {
                      setSelectedIncomeCard(card);
                      setIncomeDetailMonth(
                        incomeDetailMonthChoices[new Date().getMonth()],
                      );
                      setIncomeDetailYear(String(new Date().getFullYear()));
                      setSelectedIncomeApartment("All apartments");
                    }}
                  >
                    <div className="report-card-top">
                      <div className={`icon-wrapper ${card.iconClass}`}>
                        {card.icon}
                      </div>
                      <div className="card-heading">
                        <h4>{card.title}</h4>
                        <p>{fmt.format(amount)}</p>
                      </div>
                    </div>

                    <div className="report-card-metrics">
                      <div className="metric-block">
                        <span className="label">% Collected</span>
                        <div className="value-row">
                          <span className="value">{percentCollected}%</span>
                        </div>
                      </div>

                      <div className="metric-block">
                        <span className="label">% Balance Left</span>
                        <span className="value">{percentBalance}%</span>
                      </div>
                    </div>
                  </button>
                );
              });
            })()}
          </div>

          <div className="amount-panel">
            <div className="amount-collected-card" ref={visitChartRef}>
              <div className="amount-card-header">
                <h3>Amount Collected</h3>
                <button type="button" className="amount-range-button">
                  Monthly
                </button>
              </div>

              <div className="amount-chart-bars">
                <div className="amount-chart-grid" aria-hidden="true">
                  {yTicks.map((tick) => (
                    <div key={tick} className="grid-row">
                      <span>{formatShortAmount(tick)}</span>
                      <div className="line" />
                    </div>
                  ))}
                </div>

                {visitChartData.map((item) => {
                  const heightPercent = maxAmount
                    ? Math.max(10, (item.amount / maxAmount) * 100)
                    : 10;
                  const isHovered = hoveredVisitPoint?.month === item.month;
                  const isDimmed = Boolean(hoveredVisitPoint) && !isHovered;
                  const isDefaultActive =
                    !hoveredVisitPoint &&
                    (currentMonthInData
                      ? item.month === currentMonthShort
                      : item.highlighted);
                  return (
                    <div
                      className={`bar-item ${isHovered || isDefaultActive ? "active" : ""} ${isDimmed ? "dimmed" : ""}`}
                      key={item.month}
                    >
                      <div className="bar-track">
                        <div
                          className="bar"
                          style={{ height: `${heightPercent}%` }}
                          aria-label={`${item.month} amount ${formatAmount(item.amount)}, ${item.transactions} payments`}
                          onMouseEnter={(event) =>
                            handleVisitHover(event, item)
                          }
                          onMouseLeave={() => setHoveredVisitPoint(null)}
                        />
                      </div>
                      <span className="month">{item.month}</span>
                    </div>
                  );
                })}
              </div>

              {hoveredVisitPoint && (
                <div
                  className="amount-tooltip"
                  style={{
                    left: `${hoveredVisitPoint.left}px`,
                    top: `${hoveredVisitPoint.top}px`,
                  }}
                >
                  <div className="tooltip-month">
                    {hoveredVisitPoint.month} {currentYear} -{" "}
                    {hoveredVisitPoint.transactions} payments
                  </div>
                  <div className="tooltip-row">
                    <span
                      className="tooltip-dot"
                      style={{ background: hoveredVisitPoint.color }}
                    />
                    <div className="tooltip-values">
                      <div className="tooltip-amount">
                        Amount: {formatAmount(hoveredVisitPoint.amount)}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* vertical divider between left and right */}
        <div className="divider" />

        <div className="right-side">
          {/* <div className="top-section-reports">
            <div className="introduction">
              <div className="title">
                Property Reports
                <div className="description">
                f
                </div>
              </div>
            </div>
            
          </div> */}
          <MyCalendar />

          <div className="day-transactions-section">
            {/* <h3>Day Transactions</h3> */}

            <div className="day-transactions-list">
              {(showAllTransactions
                ? dayTransactions
                : dayTransactions.slice(0, 4)
              ).map((transaction) => {
                const fmt = new Intl.NumberFormat();
                return (
                  <div
                    className="day-transaction-item"
                    key={`${transaction.firstName}-${transaction.apartment}`}
                  >
                    <div className="day-transaction-left">
                      <div
                        className={`icon-tile ${transaction.avatarClass || ""}`}
                      >
                        {transaction.profileUrl ? (
                          <img
                            src={transaction.profileUrl}
                            alt={`${transaction.firstName} avatar`}
                            className="avatar-img"
                          />
                        ) : (
                          <div
                            className="avatar-placeholder"
                            aria-hidden="true"
                          >
                            {/* {transaction.initials} */}
                          </div>
                        )}
                      </div>

                      <div className="day-transaction-content">
                        <div className="day-transaction-title">
                          {transaction.firstName} — {transaction.apartment}
                        </div>
                        <div className="day-transaction-time">
                          {fmt.format(transaction.amount)}
                        </div>
                      </div>
                    </div>

                    <button
                      className="day-transaction-chevron"
                      aria-label={`Open ${transaction.firstName}`}
                      type="button"
                    >
                      <IoIosArrowForward />
                    </button>
                  </div>
                );
              })}
            </div>

            <div className="see-more-wrapper">
              <button
                type="button"
                className="see-more-button"
                onClick={() => setShowAllTransactions((s) => !s)}
              >
                {showAllTransactions ? "See less" : "See more"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
